import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { mapState, mapMutations, mapGetters } from 'vuex';
export default {
  name: 'CoreFavoriteselect',
  props: {
    userId: {
      type: String,
      required: false,
      default: ''
    },
    objectId: {
      type: Number,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: true
    },
    asRoundButton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      favStatus: null,
      favId: null,
      favObject: null,
      favObjectId: null,
      loading: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    icon: function icon() {
      return this.favObjectId ? 'fas fa-star' : 'fal fa-star';
    }
  }),
  watch: {
    objectId: function objectId() {
      if (this.objectId) {
        this.getStatus();
      }
    }
  },
  mounted: function mounted() {
    if (this.objectId) {
      this.getStatus();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    getStatus: function getStatus() {
      var _this = this;

      var user;
      this.loading = true;

      if (!this.userId) {
        user = this.sessionUserId;
      } else {
        user = this.userId;
      }

      return ApiService.getFavoritesByObjectIdUserId(this.objectId, user, this.type).then(function (result) {
        result ? _this.favObjectId = result.id : _this.favObjectId = null;
        _this.favObject = result;
        return result;
      }).catch(function (error) {
        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack('Failed to load Favorite', 'error');
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    process: function process() {
      var _this2 = this;

      var user;

      if (!this.userId) {
        user = this.sessionUserId;
      } else {
        user = this.userId;
      } // clear cache, as the twin favourite-filter needs to fetch new stuff


      this.$store.state.app.dtwins = {};

      if (!this.favObjectId) {
        var data = {
          userId: user,
          objectId: this.objectId,
          type: this.type
        };
        return ApiService.createFavorite(data).then(function () {
          _this2.getStatus();
        }).catch(function (error) {
          if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
            _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this2.$snack('Failed to create Favorite', 'error');
          }
        });
      } else {
        return ApiService.deleteFavorite(this.favObjectId).then(function () {
          _this2.getStatus();
        }).catch(function (error) {
          if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
            _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this2.$snack('Failed to delete Favorite', 'error');
          }
        });
      }
    }
  })
};